import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, TextField } from "@mui/material";
import { FtpSettings } from "../../api";
import { PasswordField } from "../controls";

export interface FtpSettingsControlProps {
  settings?: FtpSettings;
  onChange: (settings: Partial<FtpSettings>) => void;
}

export const FtpSettingsControl = (props: FtpSettingsControlProps) => {
  const { settings, onChange } = props;

  return (
    <FormControl component="fieldset" sx={{ minWidth: 150 }}>
      <FormLabel component="legend">FTP settings</FormLabel>
      <FormGroup>
        <TextField label="Host" required variant="standard" value={settings?.host ?? ""} onChange={(e) => onChange({ host: e.target.value })} />
        <TextField label="Username" variant="standard" value={settings?.username ?? ""} onChange={(e) => onChange({ username: e.target.value })} />
        <PasswordField label="Password" variant="standard" value={settings?.password ?? ""} onChange={(e) => onChange({ password: e.target.value })} />
        <TextField label="Port" variant="standard" type="number" value={settings?.port ?? ""} onChange={(e) => onChange({ port: e.target.value })} />
        <FormControlLabel label="Secure" control={<Checkbox checked={settings?.secure ?? false} onChange={(e, c) => onChange({ secure: c })} />} />
      </FormGroup>
    </FormControl>
  );
};
